import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import FileUpload from "./FileUpload";
import { toast } from "react-toastify";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [selectedFile, setSelectedFile] = useState({
    preview: null,
    path: "",
  })
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "companyProfileUpload",
      })
    );

  }, [dispatch]);

  useEffect(() => {
    reset(section);

   

    setSelectedImage({
      preview: null,
      path: section?.image,
    });
    setSelectedFile({
      preview: null,
      path: section?.file,
    })
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }

    data.image = selectedImage.path;
    data.file = selectedFile.path
    

    dispatch(
      editSection({ slug: "companyProfileUpload", page: "home", data: { section: data } , toast })
    );
  };
  console.log("section :error", errors);

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"companyUpload"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12} sm={12}>
                <Row>

                  {/* image  */}
                  <Col lg={6} sm={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"image"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>

                  {/* file */}

                  <Col lg={6} sm={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"file"} />
                      </h5>
                      <FileUpload selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                      defaultValue={section.section?.heading?.ar || ""}

                    />

                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                      defaultValue={section.section?.heading?.en || ""}
                    />
                  </Col>
                </Row>


                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
